import React, { useState, useMemo } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer, toast } from "react-toastify";
import FeeSystemMenu from "./FeeSystemMenu";
import config from "../../Config";

const MONTHS = [
  { value: 1, label: "Jan" }, { value: 2, label: "Feb" }, { value: 3, label: "Mar" },
  { value: 4, label: "Apr" }, { value: 5, label: "May" }, { value: 6, label: "Jun" },
  { value: 7, label: "Jul" }, { value: 8, label: "Aug" }, { value: 9, label: "Sep" },
  { value: 10, label: "Oct" }, { value: 11, label: "Nov" }, { value: 12, label: "Dec" },
];

const GenerateAdvanceChallan = () => {
  const now = new Date();
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [RegistrationNo, setRegistrationNo] = useState("");
  const [StudentId, setStudentId] = useState("");
  const [studentInfo, setStudentInfo] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [AdvanceAmount, setAdvanceAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [generatedChallan, setGeneratedChallan] = useState("");
  const [generatedAmount, setGeneratedAmount] = useState("");
  const [SelectedMonth, setSelectedMonth] = useState(now.getMonth() + 1);
  const [FYear, setFYear] = useState(now.getFullYear());
  const [DueDay, setDueDay] = useState(25);

  const dueDateString = useMemo(() => {
    const daysInMonth = new Date(FYear, SelectedMonth, 0).getDate();
    const day = Math.min(Math.max(1, DueDay), daysInMonth);
    return `${FYear}-${String(SelectedMonth).padStart(2, "0")}-${String(day).padStart(2, "0")}T00:00:00`;
  }, [FYear, SelectedMonth, DueDay]);

  const handleSearch = async (e) => {
    e.preventDefault();
    setStudentInfo(null);
    setGeneratedChallan("");

    if (!RegistrationNo && !StudentId) {
      toast.error("Please enter registration number or student ID.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    setSearchLoading(true);
    try {
      let studentIdValue = StudentId;
      if (!studentIdValue && RegistrationNo) {
        const regResp = await axios({
          method: "post",
          url: config.base_url + "Student/GetStudentByRegistrationNo",
          headers: { "Content-Type": "application/json" },
          data: { AccessKey, UserID, MemberType, Registration_No: RegistrationNo },
        });
        if (regResp.data.status_code !== 1 || !regResp.data.Student) {
          toast.error(regResp.data.status_message || "Student not found.", { position: toast.POSITION.TOP_RIGHT });
          setSearchLoading(false);
          return;
        }
        studentIdValue = regResp.data.Student.Student_ID;
      }

      const detailResp = await axios({
        method: "post",
        url: config.base_url + "Student/GetStudentByID",
        headers: { "Content-Type": "application/json" },
        data: { AccessKey, UserID, MemberType, ID: studentIdValue },
      });

      if (detailResp.data.status_code === 1 && detailResp.data.Student) {
        setStudentInfo(detailResp.data.Student);
        toast.success("Student loaded. Enter advance amount and generate challan.", { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.error(detailResp.data.status_message || "Student not found.", { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      toast.error("Network Error.", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setSearchLoading(false);
    }
  };

  const handleGenerate = (e) => {
    e.preventDefault();
    setGeneratedChallan("");
    const amount = parseFloat(AdvanceAmount);
    if (!studentInfo) {
      toast.error("Please search and select a student first.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    if (!AdvanceAmount || isNaN(amount) || amount <= 0) {
      toast.error("Please enter a valid advance amount (greater than 0).", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "ADLedger/GenerateAdvanceFeeChallan",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        Registration_No: studentInfo.Registration_No || "",
        Student_ID: studentInfo.Student_ID,
        Amount: amount,
        SelectedMonth,
        FYear,
        Challan_DueDate: dueDateString,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setGeneratedChallan(response.data.Challan_No || "");
          setGeneratedAmount(response.data.Amount);
          toast.success(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
        } else {
          toast.error(response.data.status_message || "Failed to generate challan.", { position: toast.POSITION.TOP_RIGHT });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network Error.", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                  <li className="breadcrumb-item"><Link to="/FeeSystem/FeeSystemDashboard">Fee System</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Generate Advance Fee Challan</li>
                </ol>
              </nav>
              <div className="page-title">Generate Advance Fee Challan</div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <p className="text-muted mb-4">
                Generate a challan for <strong>advance fee</strong> so the parent can pay the amount at the bank or via Kuickpay. Advance challan is for <strong>registered students only</strong>. Challan number format: YY + MM + sequence + Registration No (e.g. 260301 + RegNo). After generation, print the challan and give it to the parent.
              </p>

              <form onSubmit={handleSearch} className="mb-4">
                <div className="row g-3 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label">Registration No</label>
                    <input
                      type="text"
                      className="form-control"
                      value={RegistrationNo}
                      onChange={(e) => setRegistrationNo(e.target.value)}
                      placeholder="e.g. 12345"
                    />
                  </div>
                  <div className="col-md-2">
                    <span className="d-block text-center text-muted">OR</span>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Student ID</label>
                    <input
                      type="number"
                      className="form-control"
                      value={StudentId}
                      onChange={(e) => setStudentId(e.target.value)}
                      placeholder="Student ID"
                    />
                  </div>
                  <div className="col-md-3">
                    <button type="submit" className="button button-primary w-100" disabled={searchLoading}>
                      {searchLoading ? <Spinner animation="border" size="sm" /> : "Search Student"}
                    </button>
                  </div>
                </div>
              </form>

              {studentInfo && (
                <>
                  {!studentInfo.Registration_No || String(studentInfo.Registration_No).trim() === "" ? (
                    <div className="alert alert-warning mb-4">
                      Advance fee challan can be generated for <strong>registered students only</strong>. This student has no registration number. Please add a registration number for this student first.
                    </div>
                  ) : (
                  <>
                  <div className="alert alert-light border mb-4">
                    <strong>Selected:</strong> {studentInfo.Student_Name} (Reg: {studentInfo.Registration_No})
                  </div>

                  <form onSubmit={handleGenerate}>
                    <div className="row g-3 align-items-end mb-3">
                      <div className="col-md-2">
                        <label className="form-label">Month</label>
                        <select
                          className="form-select"
                          value={SelectedMonth}
                          onChange={(e) => setSelectedMonth(Number(e.target.value))}
                        >
                          {MONTHS.map((m) => (
                            <option key={m.value} value={m.value}>{m.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Year</label>
                        <select
                          className="form-select"
                          value={FYear}
                          onChange={(e) => setFYear(Number(e.target.value))}
                        >
                          {[now.getFullYear() - 1, now.getFullYear(), now.getFullYear() + 1].map((y) => (
                            <option key={y} value={y}>{y}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Due date (day)</label>
                        <input
                          type="number"
                          min={1}
                          max={31}
                          className="form-control"
                          value={DueDay}
                          onChange={(e) => setDueDay(Math.min(31, Math.max(1, Number(e.target.value) || 1)))}
                        />
                      </div>
                    </div>
                    <div className="row g-3 align-items-end mb-4">
                      <div className="col-md-4">
                        <label className="form-label">Advance Amount (Rs)</label>
                        <input
                          type="number"
                          step="0.01"
                          min="0.01"
                          className="form-control"
                          value={AdvanceAmount}
                          onChange={(e) => setAdvanceAmount(e.target.value)}
                          placeholder="e.g. 50000"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <button type="submit" className="button button-primary" disabled={loading || !studentInfo.Registration_No}>
                          {loading ? <Spinner animation="border" size="sm" className="me-1" /> : null}
                          Generate Advance Challan
                        </button>
                      </div>
                    </div>
                  </form>
                  </>
                  )}
                </>
              )}

              {generatedChallan && (
                <div className="alert alert-success">
                  <h6 className="alert-heading">Advance fee challan generated</h6>
                  <p className="mb-1"><strong>Challan No:</strong> {generatedChallan}</p>
                  <p className="mb-1"><strong>Amount:</strong> Rs {Number(generatedAmount).toLocaleString()}</p>
                  <p className="mb-3">Parent can pay this amount at the bank or via Kuickpay using the challan number above.</p>
                  <NavLink
                    to={`/students/PrintVoucher?ChallanNos=${generatedChallan}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button button-primary"
                  >
                    Print Challan
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateAdvanceChallan;
